<template>
    <article v-if="isScreen" :id="'wishlist-item-' + glass.id" class="glasses-list-item">
      <button class="btn eon-btn-remove" @click.stop="removeItem(glass.article_nr, glass.colorNr)"><i
          class="fa fa-remove eon-remove-icon"></i> <span class="eon-btn-remove-label">{{ lb_remove }}</span></button>
      <div class="glass-item-inner">
        <div class="glass-item-image-holder">
          <a ref="imglink" class="glass-item-link" :href="getUrl(glass.colorNr)">
            <img ref="main" :src="mainImage()" class="img-fluid"/>
          </a>
          <div class="glass-item-text-holder">
            <h5 class="glass-item-title">{{ glass.brandlabel }}</h5>
            <h5 class="glass-item-title">{{ glass.article_nr }} col. {{ glass.colorNr }}</h5>
          </div>
        </div>
      </div>
    </article>
  <div v-else>
    <div class="pdf-item-container" style="break-inside: avoid; page-break-inside: avoid;">
      <table class="eon-pdf-item-outer-table">
        <tbody>
        <tr>
          <td class="w-50">
            <img :src="mainImage()" alt="{{glass.article_nr}}" class="pdf-mainimage">
          </td>
          <td style="text-align:center;border:none;font-size:10pt;">
            <table class="model-desc">
              <tbody>
              <tr>
                <td>
                  <img class="pdf-brand-image"
                       :src="getAssetUrl('/brands/' + glass.brand.toLowerCase() + '-brand-logo.png')" alt="brand image">
                </td>
                <td>
                  <div class="hline"></div>
                  <div class="model-text">
                    {{ translate('model')}} {{ glass.article_nr }}<br />col. {{ glass.colorNr }}
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="hr"></div>
      <div class="d-flex">
        <div class="pdf-existing-colors w-50">
          <div class="color-heading">
            {{ translate('Available colours') }}:
          </div>
          <div class="color-list">
            <div class="color-item" v-for="(color, index) in colors" :key="index">

              <img :src="getImage(color.image)" class="img-fluid" :title="'col. ' + color.color_nr">

              <div class="color-switcher-title">
                col. {{ color.color_nr }}
              </div>
            </div>
          </div>
        </div>
        <div class="pdf-properties">
          <div class="properties-heading">
            {{ translate('Characteristics') }}:
          </div>
          <div class="d-flex flex-row justify-content-between">
            <div class="p-col-1">
              <div class="p-row p-row-1">
                <img class="prop-icon glass-detail-icon" src="./images/icons/buegellaenge.png">
                <span class="p-size">{{ glass.buegellaenge }}&nbsp;mm</span>
              </div>
              <div class="p-row p-row-2">
                <img class="prop-icon glass-detail-icon" src="./images/icons/weight.png">
                <span class="p-size">{{ glass.weight }}&nbsp;g</span>
              </div>
              <div class="p-row p-row-3">
                <img class="prop-icon glass-detail-icon" src="./images/icons/brueckenweite.png">
                <span class="p-size">{{ glass.brueckenweite }}&nbsp;mm</span>
              </div>
            </div>
            <div class="p-col-2">
              <div class="p-row p-row-1">
                <img class="prop-icon glass-detail-icon" src="./images/icons/scheibenlaenge.png">
                <span class="p-size">{{ glass.scheibenlaenge }}&nbsp;mm</span>
              </div>
              <div class="p-row p-row-2">
                <img class="prop-icon glass-detail-icon" src="./images/icons/scheibenhoehe.png">
                <span class="p-size">{{ glass.scheibenhoehe }}&nbsp;mm</span>
              </div>
              <div class="p-row p-row-3">

              </div>
            </div>
            <div class="p-col-3">
              <div v-if="glass.verglasbar" class="p-row">
                {{ translate('Glazeable') }}
              </div>
              <div v-if="glass.federscharnier" class="p-row">
                {{ translate('Spring hinge') }}
              </div>
              <div v-if="glass.verspiegelung" class="p-row">
                {{ translate('Mirrored') }}
              </div>
              <div v-if="glass.farbverlauf" class="p-row">
                {{ translate('Colour gradient') }}
              </div>
              <div class="p-row">
                {{ translate('Material') }}:
                {{ translate(glass.material) }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="index % 3 !== 2" class="pdf-border-bottom"></div>
    </div>
  </div>
</template>
<script>
import config from '../config.js'
import {computed} from 'vue'

export default {
  name: "GlassItem",
  emits: ["remove"],
  props: {
    Glassitem: Object,
    baseurl: String,
    assetsBaseUrl: String,
    lb_remove: String,
    isScreen: Boolean,
    index: Number,
    translate: Function

  },
  data() {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  setup(props) {
    const glass = computed(() => {
      return props.Glassitem
    })
    const colors = computed(() => {
      return props.Glassitem.colors
    })
    const currentimage = computed(() => {
      return config.glassesBaseUrl + glass.value.colorImage.image
    })
    return {
      glass,
      colors,

      getImage(fname) {
        return config.glassesBaseUrl + fname
      },
      mainImage: function () {
        return this.currentimage
      },
      getAssetUrl: function (path) {
        return config.themesMediaBaseUrl + path
      },
      currentimage
    }
  },
  methods: {
    removeItem: function (article_nr, colorNr) {
      this.$emit("remove", {'article_nr': article_nr, 'colorNr': colorNr});
    },
    getUrl: function (color_nr) {
      return this.baseurl + this.glass.article_nr + color_nr
    },
  }
};
</script>

<style scoped>
@import "glassitem.css";
</style>